<template>
  <div class="side-bar" :style="{ backgroundColor: 'rgb(32, 75, 117)' }">
    <NMenu
      :options="options"
      :on-update:value="handleMenuClick"
      :render-label="renderMenuLabel"
      :render-option="renderMenuOption"
      style="width: 100%"
      default-value="DashBoard"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, h, VNode } from "vue"; // VNode 임포트 추가

import { useRouter } from "vue-router";
const router = useRouter();
import { NMenu, MenuOption } from "naive-ui";
import { USER_ROUTES } from "@/assets/route_constants";
const options = ref<MenuOption[]>([
  {
    label: "DashBoard",
    key: USER_ROUTES.DashBoard.Name,
    level: 0,
  },
  {
    label: "상품 관리",
    key: "GroupProduct",
    level: 0,
    children: [
      {
        label: "기관",
        key: USER_ROUTES.Product.Name,
        level: 1,
      },
      {
        label: "개인",
        key: USER_ROUTES.PersonalProduct.Name,
        level: 1,
      },
    ],
  },
  {
    label: "기관 및 사용자 관리",
    key: "GroupUser",
    level: 0,
    children: [
      {
        label: "기관",
        key: USER_ROUTES.Organization.Name,
        level: 1,
      },
      {
        label: "개인",
        key: USER_ROUTES.Personal.Name,
        level: 1,
      },
    ],
  },
  {
    label: "진단 검사 관리",
    key: "GroupTesting",
    level: 0,
    children: [
      {
        label: "기관",
        key: "GroupTestingOrg",
        level: 1,
        children: [
          {
            label: "견적 요청서 관리",
            key: USER_ROUTES.OrgOrderQuotation.Name,
            level: 2,
          },
          {
            label: "견적 관리",
            key: USER_ROUTES.OrgOrder.Name,
            level: 2,
          },
          {
            label: "검사 현황",
            key: USER_ROUTES.OrgDiagnosis.Name,
            level: 2,
          },
          {
            label: "결제 관리",
            key: USER_ROUTES.OrgPayment.Name,
            level: 2,
          },
        ],
      },
      {
        label: "개인",
        key: "GroupTestingPersonal",
        level: 1,
        children: [
          {
            label: "신청 관리",
            key: USER_ROUTES.PersonalOrder.Name,
            level: 2,
          },
          {
            label: "검사 현황",
            key: USER_ROUTES.PersonalDiagnosis.Name,
            level: 2,
          },
          {
            label: "결제 관리",
            key: USER_ROUTES.PersonalPayment.Name,
            level: 2,
          },
        ],
      },
    ],
  },
  {
    label: "매출 관리",
    key: USER_ROUTES.Sales.Name,
    level: 0,
  },
  {
    label: "공지 관리",
    key: USER_ROUTES.Notice.Name,
    level: 0,
  },
  {
    label: "FAQ 관리",
    key: USER_ROUTES.Qna.Name,
    level: 0,
  },
  {
    label: "홍보 관리",
    key: USER_ROUTES.Press.Name,
    level: 0,
  },
  {
    label: "문의 관리",
    key: "GroupInquiry",
    level: 0,
    children: [
      {
        label: "개인 문의",
        key: USER_ROUTES.Myreg.Name,
        level: 1,
      },
      // {
      //   label: "기관 문의",
      //   key: USER_ROUTES.OrgMyreg.Name,
      //   level: 1,
      // },
    ],
  },
  {
    label: "통계",
    key: USER_ROUTES.Statistics.Name,
    level: 0,
  },
]);

const activeKey = ref((router.currentRoute.value.name as string) || USER_ROUTES.DashBoard.Name);

const renderMenuOption = ({ node, option }: { node: VNode; option: MenuOption }) => {
  const newProps = { ...node.props };
  if ((option as any).level !== undefined) {
    newProps["data-level"] = (option as any).level;
  }
  return h(node.type as any, newProps, node.children);
};

const renderMenuLabel = (option: MenuOption) => {
  const level = (option as any).level !== undefined ? (option as any).level : 0;
  const depth = level;
  const basePadding = 15;
  const indentPerLevel = 15;
  const calculatedPaddingLeft = basePadding + depth * indentPerLevel;

  return h(
    "div",
    {
      "data-custom-level": level,
      style: {
        paddingLeft: `${calculatedPaddingLeft}px`,
        textAlign: "left",
        boxSizing: "border-box",
      },
    },
    option.label as string
  );
};

function handleMenuClick(key: string, item: MenuOption) {
  if (!item.children || item.children.length == 0) {
    activeKey.value = key;
    router.push({ name: key });
  }
}
</script>

<style scoped>
.side-bar {
  width: 200px;
  height: calc(100vh - 75px);
  display: flex;
  float: left;
}

:deep(.n-menu.n-menu--vertical) {
  width: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
  --n-item-text-color: white !important;
  background-color: transparent !important;
  text-align: left !important;
}

:deep(.n-menu-item) {
  padding: 0 !important;
  display: block !important;
  text-align: left !important;
}

:deep(.n-menu .n-menu-item-content) {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-start !important;
  width: 100% !important;
  height: 100% !important;
  padding-left: 0px !important;
  padding-right: 5px !important;
  box-sizing: border-box !important;
  background-color: transparent !important;
  color: white !important;
  transition: background-color 0.2s ease-in-out;

  grid-template-areas: unset !important;
  grid-template-columns: unset !important;
}

:deep(.n-menu .n-menu-item-content__indent) {
  display: none !important;
}

:deep(.n-menu .n-menu-item-content .n-menu-item-content__arrow) {
  margin-left: auto !important;
  margin-right: 10px;
  color: white !important;
}
:deep(.n-menu .n-menu-item-arrow .n-icon svg) {
  fill: white !important;
}
:deep(.n-menu-item[data-level="1"] > .n-menu-item-content) {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

:deep(.n-menu-item[data-level="2"] > .n-menu-item-content) {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

:deep(.n-menu-item:hover > .n-menu-item-content) {
  background-color: rgba(255, 255, 255, 0.2) !important;
}

:deep(.n-menu-item.n-menu-item--selected > .n-menu-item-content) {
  background-color: rgba(255, 255, 255, 0.3) !important;
}
</style>
